// removed by extract-text-webpack-plugin
module.exports = {"creditCardIcon":"payment-methods__creditCardIcon__a3bb8c63"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/payment-methods.scss
// module id = 1853
// module chunks = 7 16